var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform } from 'class-transformer';
import { IsArray, IsBoolean, IsIn, IsInt, IsOptional, IsString, Min } from 'class-validator';
import { CommonRequestWithLanguageQueryDTO } from '../../commons';
export class OfferFilterQueryRequest extends CommonRequestWithLanguageQueryDTO {
}
__decorate([
    IsOptional(),
    IsBoolean(),
    Transform(({ value }) => value === 'true'),
    __metadata("design:type", Boolean)
], OfferFilterQueryRequest.prototype, "onlyActive", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    Transform(({ value }) => value.split(',').map(Number)),
    __metadata("design:type", Array)
], OfferFilterQueryRequest.prototype, "roles", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    Transform(({ value }) => value.split(',').map(Number)),
    __metadata("design:type", Array)
], OfferFilterQueryRequest.prototype, "techs", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], OfferFilterQueryRequest.prototype, "text", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], OfferFilterQueryRequest.prototype, "currency", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(0),
    Transform(({ value }) => Number(value)),
    __metadata("design:type", Number)
], OfferFilterQueryRequest.prototype, "minSalaryInK", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    Transform(({ value }) => value.split(',')),
    __metadata("design:type", Array)
], OfferFilterQueryRequest.prototype, "remoteOptions", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    Transform(({ value }) => value.split(',').map(String)),
    __metadata("design:type", Array)
], OfferFilterQueryRequest.prototype, "locations", void 0);
__decorate([
    IsOptional(),
    IsIn(['EN', 'ES']),
    __metadata("design:type", String)
], OfferFilterQueryRequest.prototype, "offerLanguage", void 0);
//# sourceMappingURL=offer-filter-query.request.js.map